const DEFAULT_PATIENTS_DATA = {
  main: {
    id: -1,
    isMain: true,
    isOther: false,
    fio: 'Я',
  },
  other: {
    id: -2,
    isMain: false,
    isOther: true,
    fio: 'Другой человек',
  },
}

const MAX_FIO_LENGTH = 30

const MAX_FIO_LENGTH_YDOC = 100

const MIN_BIRTH_YEAR = 1900

const REQUIRED_FIO_DESCRIPTION = {
  name: 'Укажите имя',
  surname: 'Укажите фамилию',
  patronymic: 'Заполните поле или отметьте, что отчества нет',
}

const FAMILY_PROFILES_SESSION_STORAGE_KEY = '__pd_AppointmentPageFamilyProfiles'

export {
  DEFAULT_PATIENTS_DATA,
  MAX_FIO_LENGTH,
  MIN_BIRTH_YEAR,
  REQUIRED_FIO_DESCRIPTION,
  FAMILY_PROFILES_SESSION_STORAGE_KEY,
  MAX_FIO_LENGTH_YDOC,
}
